import { CommonModule, isPlatformBrowser } from '@angular/common';
import { InjectionToken, NgModule, PLATFORM_ID } from '@angular/core';
import { RouterModule, Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { PDPRepository } from '@repos/pdp.repository';
import { CounterComponent } from '@shared/components/counter/counter.component';
import { PopUpComponent } from '@shared/components/pop-up/pop-up.component';
import { SharedModule } from '@shared/shared.module';
import { CommentsModalComponent } from './components/comments-modal/comments-modal.component';
import { PdpCommentsPopupComponent } from './components/pdp-comments-popup/pdp-comments-popup.component';
import { PdpMobileAffixComponent } from './components/pdp-mobile-affix/pdp-mobile-affix.component';
import { PdpRoomsSkeletonComponent } from './components/pdp-rooms-skeleton/pdp-rooms-skeleton.component';
import { PdpSidebarReserveInfoComponent } from './components/pdp-sidebar-reserve-info/pdp-sidebar-reserve-info.component';
import { PdpStickyTabsComponent } from './components/pdp-sticky-tabs/pdp-sticky-tabs.component';
import { SimilarHotelsCardComponent } from './components/similar-hotels-card/similar-hotels-card.component';
import { hotelInfoResolver } from './resolvers/hotel-info.resolver';
import { HotelInfoComponent } from './hotel/hotel-info.component';
import { AboutHotelComponent } from './sections/about-hotel/about-hotel.component';
import { CommentsComponent } from './sections/comments/comments.component';
import { DistanceComponent } from './sections/distance/distance.component';
import { FaqComponent } from './sections/faq/faq.component';
import { HotelFacilitiesComponent } from './sections/hotel-facilities/hotel-facilities.component';
import { HotelRulesComponent } from './sections/hotel-rules/hotel-rules.component';
import { PdpMapComponent } from './sections/map/map.component';
import { PdpBreadcrumbComponent } from './sections/pdp-breadcrumb/pdp-breadcrumb.component';
import { PdpGalleryWrapperComponent } from './sections/pdp-gallery-wrapper/pdp-gallery-wrapper.component';
import { PdpHotelBaseDataComponent } from './sections/pdp-hotel-base-data/pdp-hotel-base-data.component';
import { PdpRoomsWrapperComponent } from './sections/pdp-rooms-wrapper/pdp-rooms-wrapper.component';
import { PdpStickySidebarComponent } from './sections/pdp-sticky-sidebar/pdp-sticky-sidebar.component';
import { HotelInfoUiService } from './services/hotel-info-ui.service';
import { PersianToEnglishRegexPipe } from '@shared/pipes/persianToEnglish.pipe';
import { MatDialogModule } from '@angular/material/dialog';
import { PdpSkeletonComponent } from './components/pdp-skeleton/pdp-skeleton.component';
import { SearchResultUiService } from './../search-result/services/search-result-ui.service';
import { PLPRepository } from '@core/services/repositories/plp.repository';
import { SafarmarketPixelComponent } from './components/safarmarket-pixel/safarmarket-pixel.component';
import { IhoPlusComponent } from './sections/ihoplus/ihoplus.component';
import { BottomNavMobileComponent } from './../home/components/bottom-nav-mobile/bottom-nav-mobile.component';
import { PdpRoomsCardsComponent } from './components/pdp-rooms-cards/pdp-rooms-cards.component';
import { RelatedlinksComponent } from '../search-result/components/relatedlinks/relatedlinks.component';
import { EcolodgeInfoComponent } from './ecolodge/ecolodge-info.component';
import { AccommodationComponent } from './accommodation.component';
import { PdpEcolodgeGeneralInfoComponent } from './ecolodge/sections/pdp-ecolodge-general-info/pdp-ecolodge-general-info.component';
import { PdpEcolodgeRestroomsComponent } from './ecolodge/sections/pdp-ecolodge-restrooms/pdp-ecolodge-restrooms.component';
import { PdpEcolodgeMapComponent } from './ecolodge/sections/pdp-ecolodge-map/pdp-ecolodge-map.component';
import { PdpEcolodgeCalenderPriceComponent } from './ecolodge/sections/pdp-ecolodge-calender-price/pdp-ecolodge-calender-price.component';
import { PdpDatepickerComponent } from './components/pdp-datepicker/pdp-datepicker.component';
import { PdpEcolodgeHostComponent } from './ecolodge/sections/pdp-ecolodge-host/pdp-ecolodge-host.component';
import { PdpPriceDetailsComponent } from './components/pdp-price-details/pdp-price-details.component';
import { PdpEcolodgeOtherUnitsComponent } from './ecolodge/sections/pdp-ecolodge-other-units/pdp-ecolodge-other-units.component';
import { PdpEcolodgeDistancesComponent } from './ecolodge/sections/pdp-ecolodge-distances/pdp-ecolodge-distances.component';
import { PdpEcolodgeHostSkeletonComponent } from './ecolodge/skeletons/pdp-ecolodge-host-skeleton/pdp-ecolodge-host-skeleton.component';
import { PdpEcolodgeFacilitiesComponent } from './ecolodge/sections/pdp-ecolodge-facilities/pdp-ecolodge-facilities.component';
import { EcolodgeService } from './services/ecolodge.service';
import { PdpEcolodgePoliciesComponent } from './ecolodge/sections/pdp-ecolodge-policies/pdp-ecolodge-policies.component';
const routes: Routes = [
 {
  path: '',
  component: AccommodationComponent,
  resolve: { data: hotelInfoResolver },
 },
];

export const WINDOW = new InjectionToken<Window>('Window', {
 factory: () => window,
});

@NgModule({
 imports: [
  CommonModule,
  RouterModule.forChild(routes),
  SharedModule,
  PdpBreadcrumbComponent,
  PdpStickySidebarComponent,
  PdpHotelBaseDataComponent,
  HotelFacilitiesComponent,
  HotelRulesComponent,
  PdpStickyTabsComponent,
  BottomNavMobileComponent,
  PdpStickySidebarComponent,
  PdpSidebarReserveInfoComponent,
  CommentsComponent,
  CommentsModalComponent,
  PdpCommentsPopupComponent,
  PopUpComponent,
  PdpRoomsWrapperComponent,
  CounterComponent,
  FaqComponent,
  PdpGalleryWrapperComponent,
  DistanceComponent,
  AboutHotelComponent,
  PdpMapComponent,
  PdpDatepickerComponent,
  PdpRoomsSkeletonComponent,
  PdpMobileAffixComponent,
  SimilarHotelsCardComponent,
  MatDialogModule,
  PdpSkeletonComponent,
  SafarmarketPixelComponent,
  IhoPlusComponent,
  PdpRoomsCardsComponent,
  RelatedlinksComponent,
  PdpEcolodgeGeneralInfoComponent,
  PdpEcolodgeRestroomsComponent,
  PdpEcolodgeMapComponent,
  PdpEcolodgeCalenderPriceComponent,
  PdpEcolodgeHostComponent,
  PdpPriceDetailsComponent,
  PdpEcolodgeOtherUnitsComponent,
  PdpEcolodgeDistancesComponent,
  PdpEcolodgeHostSkeletonComponent,
  PdpEcolodgeFacilitiesComponent,
  PdpEcolodgePoliciesComponent,
 ],
 declarations: [HotelInfoComponent, EcolodgeInfoComponent, AccommodationComponent],
 providers: [
  HotelInfoUiService,
     EcolodgeService,
  PDPRepository,
  PersianToEnglishRegexPipe,
  SearchResultUiService,
  PLPRepository,
  {
   provide: WINDOW,
   useFactory: (platformId: Object) => {
    return isPlatformBrowser(platformId) ? window : {};
   },
   deps: [PLATFORM_ID],
  },
 ],
})
export class AccommodationInfoModule {
 constructor() {
 }
}
